import ScalarMenuLink_default from "./ScalarMenuLink.vue.js";
import ScalarMenuSection_default from "./ScalarMenuSection.vue.js";
import { createBlock, createTextVNode, createVNode, defineComponent, openBlock, unref, withCtx } from "vue";
import { ScalarIconDiscordLogo, ScalarIconGithubLogo } from "@scalar/icons";
var ScalarMenuSupport_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "ScalarMenuSupport",
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createBlock(ScalarMenuSection_default, null, {
				title: withCtx(() => [..._cache[0] || (_cache[0] = [createTextVNode("Resources", -1)])]),
				default: withCtx(() => [createVNode(ScalarMenuLink_default, {
					href: "https://discord.gg/scalar",
					icon: unref(ScalarIconDiscordLogo),
					target: "_blank"
				}, {
					default: withCtx(() => [..._cache[1] || (_cache[1] = [createTextVNode(" Discord ", -1)])]),
					_: 1
				}, 8, ["icon"]), createVNode(ScalarMenuLink_default, {
					href: "https://github.com/scalar/scalar",
					icon: unref(ScalarIconGithubLogo),
					target: "_blank"
				}, {
					default: withCtx(() => [..._cache[2] || (_cache[2] = [createTextVNode(" GitHub ", -1)])]),
					_: 1
				}, 8, ["icon"])]),
				_: 1
			});
		};
	}
});
//#endregion
export { ScalarMenuSupport_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ScalarMenuSupport.vue_vue_type_script_setup_true_lang.js.map